import { TextSelection as s } from "@tiptap/pm/state";
import { nanoid as t } from "nanoid";
import { createEditorVueNode as i } from "../../../helpers/nodeFactory.js";
import { renderVueElement as d } from "../../../helpers/staticRendering.js";
import { toggleCommandFactory as u } from "../../../helpers/toggleCommands.js";
import l from "./customTabs.svg.js";
import p from "./CustomTabs.vue.js";
import f from "./ScalarTabs.vue.js";
const n = "custom_tabs", r = "toggleTabs", k = {
  id: 21,
  name: "Tabs",
  command: ({ editor: e, range: o }) => u(e, o, {
    name: r,
    params: {}
  }),
  hotkey: "⌘ ⇧ 5",
  markdown: "",
  svg: l
}, y = {
  name: n,
  render(e) {
    return d(f, {
      children: e.children,
      uid: e.uid
    });
  }
}, V = i(
  {
    name: n,
    draggable: !0,
    addAttributes: () => ({
      uid: { default: "" }
    }),
    addCommands() {
      return {
        [r]: () => ({ editor: e, tr: o }) => {
          const a = e.schema.nodes.custom_container.createAndFill({
            uid: t()
          }), m = this.type.create({ uid: t() }, a), c = o.selection.anchor + 1;
          return o.replaceSelectionWith(m).scrollIntoView().setSelection(s.near(o.doc.resolve(c))), !0;
        }
      };
    },
    vueComponent: p
  },
  {
    group: "block",
    content: "custom_container+",
    parseHTML() {
      return [
        {
          tag: "vue-component"
        }
      ];
    }
  }
);
export {
  y as customTabsStatic,
  V as default,
  k as tabsSuggestion
};
